import { SELECT_ALL_OPTION } from './select-all-option.js';
import { toggleSelectAll } from './toggle-select-all.js';

type Option = Readonly<{ value: string; disabled?: boolean }>;

/**
 * The values a `DimeAutocomplete` multi-select holds after Base UI reports a pick that may be
 * Select All, which sits in its value while everything is picked: a change in Select All's
 * presence is the user picking it, and anything else is an ordinary pick; no picks at all is a clear.
 */
export function resolveSelectAll(
  next: ReadonlyArray<Option>,
  options: ReadonlyArray<Option>,
  wasAllSelected: boolean,
): string[] {
  if (next.length === 0) return [];
  const picked = next
    .map((option) => option.value)
    .filter((value) => value !== SELECT_ALL_OPTION.value);
  const hasSelectAll = next.some((option) => option.value === SELECT_ALL_OPTION.value);
  if (hasSelectAll === wasAllSelected) return picked;
  return toggleSelectAll(options, picked);
}
